import { createAction, props } from '@ngrx/store';
import { DateTime } from 'luxon';

export const Its2DashRangeSet = createAction(
    '[ITS2-DASH] Dash Filter Applied',
    props<{ since: DateTime, until: DateTime }>()
);
